export default __webpack_public_path__ + "locales/az/SMTPSettings.json?hash=d4b90148013d9949dca1cc069bf7cf56";